export default __webpack_public_path__ + "static/media/hostfully_step2.79a5d055.png";